// @flow

export const setOffsetToDOMNodes = (nodes: Array<HTMLElement>, offset: number) => {
    if (nodes.length > 0) {
        nodes.forEach(node => {
            node.style.left = `${offset}px`;
        });
    }
};
